import { render, staticRenderFns } from "./categoryOrderer.vue?vue&type=template&id=74c04ae0&"
import script from "./categoryOrderer.vue?vue&type=script&lang=js&"
export * from "./categoryOrderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports